import React from 'react';

import VideoIcon from './VideoIcon';
import CuboidsIcon from './CuboidsIcon';
import TwoDBoxesIcon from './2dBoxesIcon';
import PolygonsIcon from './PolygonsIcon';
import ComparisonIcon from './ComparisonIcon';
import AudioSpeechIcon from './AudioSpeechIcon';
import NamedEntityIcon from './NamedEntityIcon';
import LinesSplinesIcon from './LinesSplinesIcon';
import ScaleDocumentIcon from './ScaleDocumentIcon';
import PointAnnotationIcon from './PointAnnotationIcon';
import OcrTranscriptionIcon from './OcrTranscriptionIcon';
import SentimentAnalysisIcon from './SentimentAnalysisIcon';
import TextClassificationIcon from './TextClassificationIcon';
import UtteranceCollectionIcon from './UtteranceCollectionIcon';
import ImageCategorizationIcon from './ImageCategorizationIcon';
import SensorFusionCuboidsIcon from './SensorFusionCuboidsIcon';
import SemanticSegmentationIcon from './SemanticSegmentationIcon';
import SensorFusionSegmentationIcon from './SensorFusionSegmentationIcon';

// v2
import TwoDBoxesIconV2 from './2dBoxesIconV2';
import SemanticSegmentationIconV2 from './SemanticSegmentationIconV2';
import TextClassificationIconV2 from './TextClassificationIconV2';
import ScaleDocumentIconV2 from './ScaleDocumentIconV2';
import VideoIconV2 from './VideoIconV2';
import NamedEntityIconV2 from './NamedEntityIconV2';

interface ProductIconProps {
  type?: string;
  style?: React.CSSProperties;
  useV2Icon?: boolean;
}

// eslint-disable-next-line complexity
const ProductIcon: React.FC<ProductIconProps> = ({ type, style, useV2Icon }) => {
  switch (type) {
    case 'sensor-fusion-cuboids':
    case 'lidarlinking':
    case 'lidarannotation':
    case 'lidarstitching':
    case 'lidartopdown':
      return <SensorFusionCuboidsIcon style={style} />;
    case 'sensor-fusion-segmentation':
    case 'lidarsegmentation':
      return <SensorFusionSegmentationIcon style={style} />;
    case 'semantic-segmentation':
    case 'segmentannotation':
      return useV2Icon ? (
        <SemanticSegmentationIconV2 style={style} />
      ) : (
        <SemanticSegmentationIcon style={style} />
      );
    case 'cuboids':
    case 'cuboidannotation':
      return <CuboidsIcon style={style} />;
    case 'polygonannotation':
      return <PolygonsIcon style={style} />;
    case 'twod-boxes':
    case 'boxannotation':
    case 'imageannotation':
    case 'annotation':
      return useV2Icon ? <TwoDBoxesIconV2 style={style} /> : <TwoDBoxesIcon style={style} />;
    case 'lineannotation':
    case 'laneannotation':
      return <LinesSplinesIcon style={style} />;
    case 'pointannotation':
      return <PointAnnotationIcon style={style} />;
    case 'videoboxannotation':
    case 'video-annotation':
    case 'videoannotation':
    case 'videocuboidannotation':
    case 'videoplaybackannotation':
      return useV2Icon ? <VideoIconV2 style={style} /> : <VideoIcon style={style} />;
    case 'categorization':
    case 'imagecategorization':
      return <ImageCategorizationIcon style={style} />;
    case 'textcategorization':
    case 'textclassification':
      return <TextClassificationIcon style={style} />;
    case 'comparison':
      return <ComparisonIcon style={style} />;
    case 'transcription':
      return <OcrTranscriptionIcon style={style} />;
    case 'audiospeech':
    case 'audiocollection':
    case 'audiotranscription':
    case 'datacollection':
    case 'genericdatacollection': // TODO: make a real icon for data collection
      return <AudioSpeechIcon style={style} />;
    case 'sentimentanalysis':
      return <SentimentAnalysisIcon style={style} />;
    case 'utterancecollection':
      return <UtteranceCollectionIcon style={style} />;
    case 'namedentityrecognition':
      return useV2Icon ? <NamedEntityIconV2 style={style} /> : <NamedEntityIcon style={style} />;
    case 'documenttranscription':
    case 'documentmodel':
      return useV2Icon ? (
        <ScaleDocumentIconV2 style={style} />
      ) : (
        <ScaleDocumentIcon style={style} />
      );
    case 'textcollection':
      return useV2Icon ? (
        <TextClassificationIconV2 style={style} />
      ) : (
        <TextClassificationIcon style={style} />
      );
    case 'multimodaltranscription':
      return <AudioSpeechIcon style={style} />;
    default:
      return null;
  }
};

ProductIcon.defaultProps = {
  style: { height: '24px', display: 'block' },
};

export default ProductIcon;
